<template>
  <div>
    <v-dialog v-model="photoDialog">
      <v-card>
        <img
          :src="photoDialogUrl || null" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingDialog" persistent max-width="320">
      <v-card>
        <v-progress-circular
          :size="50"
          color="amber"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>

    <v-dialog v-model="boarderDateError" persistent>
      <v-card>
        Na zadané datum mají již objednáno následující strávníci: <br>
        {{ boardersWithDateError.map(boarder => `${boarder.firstName} ${boarder.lastName}`).join(', ') }}
        <div>
          <v-btn color="success" @click="dismissBoarderDateError">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-dialog v-model="dateDialog" persistent max-width="320">
        <v-card>
          <v-card-title class="heading" style="text-align: center">Vyberte datum</v-card-title>
          <template>
            <v-date-picker
              v-model="selectedDate"
              class="mt-4"
              :min="minPickerDate"
              :max="maxPickerDate"
              full-width
              :allowed-dates="allowedDates"
              first-day-of-week="1"
              color="warning"
            ></v-date-picker>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="cancelDate">Zrušit</v-btn>
            <v-btn color="warning" @click="initializeDietDay" :disabled="datePickerDisabled">Vybrat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <div>{{selectedDate ? getLocalizedDate(selectedDate) : ''}} {{selectedDate? getLocalizedWeekDay(selectedDate) : ''}}</div>
    <v-container fluid>
      <v-row>
        <v-col
          cols="12">
          <div v-if="dayEmpty">
            Žádné položky k zobrazení
          </div>
          <div
            v-for="(time, index) in availableFood"
            :key="index">
            <v-data-table
              v-if="time.length"
              :headers="headers"
              :items="time"
              :expanded="expanded"
              item-key="name"
              show-expand
              class="elevation-0 order-table"
              hide-default-footer
              disable-sort
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title>{{timeTypes.length ? timeTypes[index].name : ''}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:item.name="{ item }">
                <span :class="{ 'special-offer': item.specialOffer }">{{item.name}}</span>
              </template>
              <template v-slot:item.photo="{ item }">
                <v-icon
                  v-if="item.imageUrl"
                  small
                  class="mr-2"
                  @click="showPhoto(item.imageUrl)"
                >
                  mdi-camera
                </v-icon>
              </template>

              <template v-slot:item.quantity="{ item }" v-if="cart.order">
                <v-text-field
                  v-if="item.editable"
                  v-model="item.quantity"
                  class="order-quantity"
                  type="number"
                  min="0"
                  dense
                >
                  <v-icon slot="prepend" color="red" @click="minusQuantity(item)">mdi-minus</v-icon>
                  <v-icon slot="append" color="green" @click="plusQuantity(item)">mdi-plus</v-icon>
                </v-text-field>
              </template>
              <template v-slot:item.quantity="{ item }" v-else>
                <v-checkbox
                  v-if="item.editable"
                  :label="item.selected ? 'Objednáno' : 'Objednat'"
                  v-model="item.selected"
                  :disabled="/* disabledDayTimeInputs[index] */false"
                  @change="selectItemBoarders(item)"
                ></v-checkbox>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  v-if="item.type === 'App\\Menu'"
                >
                  <div
                    v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
                  >{{menuItem.name}}</div>
                </td>
                <td
                  :colspan="headers.length"
                  v-else
                >{{item.name}}</td>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <template>
      <v-row justify="center">
        <v-dialog v-model="addToCartDialog" persistent max-width="650">
          <v-card>
            <v-card-title class="headline">Přidáno do košíku !</v-card-title>
            <v-card-text>Zboží bylo přidáno do košíku, můžete pokračovat v nákupu, nebo objednávku dokončit</v-card-text> {{/*TODO: fix phrases*/}}
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="order-control-buttons">
                <v-btn color="blue darken-1" text @click="continueShopping()">Další objednávka</v-btn>
                <v-btn color="primary" @click="goToCart()">Přejít do košíku</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <div class="order-control-buttons text-right">
      <v-btn text @click="cancelOrder">Zrušit</v-btn>
      <v-btn color="secondary" outlined class="mr-2" @click="goToStep(1)">Předchozí krok</v-btn>
      <v-btn color="success" class="mr-2" @click="addToCart()">Uložit do košíku</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'Step2',
  data () {
    return {
      boarderDateError: false,
      boardersWithDateError: [],
      loadingDialog: false,
      boardersOrderDates: {},
      selectedDate: null,
      dateDialog: false,
      addToCartDialog: false,
      availableFood: [[], [], [], [], [], []],
      headers: [
        { text: '', value: 'photo', sortable: false, width: 1 },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 250
        },
        { text: 'Alergeny', value: 'alergensStr', width: 250 },
        { text: 'Kalorie', value: 'calories', width: 150 },
        { text: 'Cena', value: 'price', width: 150 },
        { text: '', value: 'quantity', width: 150 },
        { text: '', value: 'data-table-expand' }
      ],
      expanded: [],
      photoDialog: false,
      photoDialogUrl: null
    }
  },
  methods: {
    dismissBoarderDateError () {
      this.boarderDateError = false
    },
    initializeDietDay () {
      // check if none of boarders has order for selected date
      this.boardersWithDateError = []
      this.availableFood = [[], [], [], [], [], []]
      for (const boarderId in this.boardersOrderDates) {
        if (this.boardersOrderDates[boarderId].includes(this.selectedDate)) {
          const boarder = this.cart.boarders.find(boarder => boarder.id === +boarderId)
          this.boardersWithDateError.push(boarder)
        }
      }
      if (this.boardersWithDateError.length) {
        this.boarderDateError = true
        return
      }

      const dietID = this.cart.diet.id
      const date = this.selectedDate
      this.dateDialog = false

      this.$http.get(`/diets/${dietID}/days/date/${date}`)
        .then(response => {
          let dietDayItems = []
          const res = this.keysToCamelCase(response.data)
          if (Object.keys(res).length) {
            dietDayItems = res.dietDayItems
          }

          const items = dietDayItems.map(item => {
            item = { ...item, ...item.eatable }
            item.alergensStr = item.alergens
              .map(alergen => alergen.name)
              .join(', ')
            item.selected = false
            item.quantity = 0
            return item
          })
          this.availableFood = this.availableFood.map((time, index) => {
            return items.filter(item => item.timeId === index + 1)
          })

          // only editable
          this.availableFood = this.availableFood.map(time => time.filter(f => f.editable))

          // map to shopping cart
          if (this.cart.items[date]) {
            this.availableFood = this.availableFood.map((time, index) => {
              if (!this.cart.items[date][index].length) {
                return time
              } else {
                return time.map(food => {
                  const shoppingCartFood = this.cart.items[date][index]
                    .find(f => f.id === food.id && f.type === food.type)
                  if (shoppingCartFood) {
                    food.selected = true
                    food.quantity = shoppingCartFood.quantity
                  }
                  return food
                })
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    cancelDate () {
      this.dateDialog = false
      this.goToStep(1)
      /* if (Object.keys(this.cart.items).length) { // TODO: updating orders that should not be edited
        this.goToStep(3)
      } else {
        this.goToStep(1)
      } */
    },
    showPhoto (url) {
      this.photoDialog = true
      const base = axios.defaults.baseURL.split('/')
      this.photoDialogUrl = `${base.slice(0, 3).join('/')}${url}`
    },
    plusQuantity (item) {
      ++item.quantity
    },
    minusQuantity (item) {
      if (item.quantity > 0) {
        --item.quantity
      }
    },
    selectItemBoarders (item) {
      this.availableFood[item.timeId - 1] = this.availableFood[item.timeId - 1]
        .map(food => {
          if (food !== item) {
            food.selected = false
            food.quantity = 0
          }
          return food
        })
      if (item.selected) {
        item.quantity = 1
        // this.cart.items[this.selectedDate][item.timeId - 1].push(item)
      } else {
        item.quantity = 0
      }
    },
    continueShopping () {
      this.dateDialog = true
      this.addToCartDialog = false
      this.expanded = []
      this.goToStep(2)
    },
    addToCart () {
      const allFood = this.availableFood.flat()

      // there is at at least 1 item with quantity > 0
      if (allFood.filter(food => food.quantity > 0).length) {
        this.cart.items[this.selectedDate] = []
        this.availableFood.forEach((time, index) => {
          this.cart.items[this.selectedDate][index] = time.filter(food => food.quantity > 0)
        })
      } else if (this.cart.items[this.selectedDate]) {
        const availableFoodEditable = !!this.availableFood
          .flat()
          .filter(f => f.editable)
          .length
        if (availableFoodEditable) {
          delete this.cart.items[this.selectedDate]
        }
      }
      this.addToCartDialog = true
      this.updateShoppingCartStorage()
    },
    goToCart () {
      this.addToCartDialog = false
      this.sortShoppingCartKeys()
      this.goToStep(3)
    },
    sortShoppingCartKeys () {
      const unordered = this.cart.items
      const ordered = {}
      Object.keys(unordered).sort().forEach(key => {
        ordered[key] = unordered[key]
      })
      this.cart.items = ordered
    },
    allowedDates (val) {
      if (this.orderObject.dates.length) {
        return this.orderObject.dates.indexOf(val) !== -1
      }
      return true
    },
    cancelOrder () {
      this.reset()
      this.$emit('order-canceled')
    },
    ...mapMutations({
      reset: 'ordering/reset',
      goToStep: 'ordering/goToOrderingStep',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage'
    })
  },
  computed: {
    maxPickerDate () {
      return this.cart.diet ? this.cart.diet.dateTo : null
    },
    minPickerDate () {
      if (!this.cart.diet) {
        return null
      }

      const today = new Date()
      const dietFrom = new Date(this.cart.diet.dateFrom)
      return dietFrom.getTime() > today.getTime()
        ? this.cart.diet.dateFrom
        : today.toISOString().slice(0, 10)
    },
    dayEmpty () {
      return !(this.availableFood
        .flat()
        .length)
    },
    datePickerDisabled () {
      if (!this.selectedDate) {
        return true
      }
      return !(this.selectedDate >= this.minPickerDate && this.selectedDate <= this.maxPickerDate)
    },
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      timeTypes: 'ordering/timeTypes',
      step: 'ordering/step',
      orderObject: 'ordering/cartOrder'
    }),
    // vuex bindings
    'cart.items': {
      get () {
        return this.$store.shoppingCart.state.cart.items
      },
      set (items) {
        this.$store.shoppingCart.state.cart.items = items
      }
    }
  },
  watch: {
    step (newVal, oldVal) {
      if (oldVal === 1 && newVal === 2) {
        this.loadingDialog = true
        if (!this.orderObject.id) {
          this.$http.post('/showOrderedDates', {
            boarder_ids: this.cart.boarders.map(boarder => boarder.id)
          })
            .then(res => {
              const response = this.keysToCamelCase(res.data)
              this.boardersOrderDates = {}
              Object.keys(response).forEach(boarderId => {
                this.boardersOrderDates[boarderId + ''] = response[boarderId]
              })
              this.dateDialog = true
              this.loadingDialog = false
            })
            .catch(err => console.log(err))
        }

        this.dateDialog = true
        this.loadingDialog = false
        this.dateDialog = true
      }
    }
  }
}
</script>

<style scoped>

.special-offer {
  color: #ff7070;
}

</style>
